import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaDocumentosLayoutsh2hDisponibles', {
    template: template,
    controller: NominaDocumentosLayoutsh2hDisponiblesComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      onClose: '&',
      onChange: '&',
    },
  })

function NominaDocumentosLayoutsh2hDisponiblesComponent($filter, NominaDocumentosLayoutsh2hDisponibles) {
  let $ctrl = this
  $ctrl.groupBy = $filter('groupBy')
  $ctrl.data = []
  $ctrl.agrupados = {}
  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar
  $ctrl.seleccionar = seleccionar
  $ctrl.cerrar = cerrar
  $ctrl.tiempoRespuesta = 3
  $ctrl.mostrarInfo = false

  function $onInit() {
    $ctrl.seleccionado = null

    $ctrl.promise = NominaDocumentosLayoutsh2hDisponibles.get($ctrl.idProyecto, $ctrl.idNomina)
      .then(function ({ data }) {
        $ctrl.tiempoRespuesta = data.tiempoRespuesta
        $ctrl.data = data.bancos
        $ctrl.agrupados = $ctrl.groupBy($ctrl.data, 'descripcion')
      })
  }

  function actualizar() {
    $ctrl.onClose()
    $ctrl.onChange()
  }

  function seleccionar(regla, banco) {
    if (!regla.disponible) return
    regla.id_banco = banco.id_banco
    regla.banco_clave = banco.clave
    regla.banco_descripcion = banco.descripcion
    $ctrl.seleccionado = regla
  }

  function cerrar(data) {
    $ctrl.onClose({ $event: { data: data } })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsh2h/disponibles/component.js